import CreateCommentForm from './CreateCommentForm';

export default CreateCommentForm;
